export class CrearCuentaCorreoPeticion {
    codCliente: string;
    codTpoPortal: string;
    docEmpresa: string;

    correoUsuario: string;
}